import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GetBaselineKpiGQL, GetBaselineKpiQuery, GetEvaluationKpiGQL, GetEvaluationKpiQuery, GetQualitativeKpiGQL, GetQualitativeKpiQuery, GetRiskMapKpiGQL, GetRiskMapKpiQuery, GetSnapshotsByYearGQL, GetSnapshotsByYearQuery } from '../../../graphql/generated';

type LegalEntityIdsParam = string[] | string | undefined | null;

@Injectable({
    providedIn: 'root'
})
export class DataMonitoringService {
    private readonly GetRiskMapKpiGQL: GetRiskMapKpiGQL = inject(GetRiskMapKpiGQL);
    private readonly GetEvaluationKpiGQL: GetEvaluationKpiGQL = inject(GetEvaluationKpiGQL);
    private readonly GetQualitativeKpiGQL: GetQualitativeKpiGQL = inject(GetQualitativeKpiGQL);
    private readonly GetBaselineKpiGQL: GetBaselineKpiGQL = inject(GetBaselineKpiGQL);
    private readonly GetSnapshotsByYearGQL: GetSnapshotsByYearGQL = inject(GetSnapshotsByYearGQL)


    getRiskMapKpi(legalEntityIds: LegalEntityIdsParam, campaignId: string, level: number): Observable<GetRiskMapKpiQuery['kpiRiskMap']> {
        return this.GetRiskMapKpiGQL.fetch({ campaignId, legalEntityIds, level }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.kpiRiskMap));
    }

    getEvaluationKpi(
        legalEntityIds: LegalEntityIdsParam,
        campaignId: string,
        level: number
    ): Observable<GetEvaluationKpiQuery> {
        return this.GetEvaluationKpiGQL.fetch({ campaignId, legalEntityIds, level }, { fetchPolicy: 'no-cache' })
            .pipe(map(result => result.data));
    }

    getQualitativeKpi(legalEntityIds: LegalEntityIdsParam, campaignId: string, level: number): Observable<GetQualitativeKpiQuery['kpiQualitative']> {
        return this.GetQualitativeKpiGQL.fetch({ legalEntityIds, campaignId, level }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.kpiQualitative));
    }

    getBaselineKpi(legalEntityIds: LegalEntityIdsParam, campaignId: string, level: number): Observable<GetBaselineKpiQuery['kpiBaseline']> {
        return this.GetBaselineKpiGQL.fetch({ legalEntityIds, campaignId, level }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.kpiBaseline));
    }

    getSnapshots(year: number): Observable<GetSnapshotsByYearQuery['snapshotsByYear']> {
        return this.GetSnapshotsByYearGQL.fetch({ year }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.snapshotsByYear))
    }
}
